var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLayout',[_c('div',[_c('h5',[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"user-lock"}}),_vm._v(" Informações compartilhadas")],1),_c('br'),(_vm.loaded)?_c('SharedProfile',{attrs:{"profile":_vm.profile,"disableInput":_vm.disableInput},on:{"save":_vm.saveRevoke,"back":_vm.backRevoke,"revokeAll":_vm.revokeAll}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }